import styled, { css } from 'styled-components';
import { borderRadius, colors, mediumShadow, spacing } from 'ui/theme';

export const AlertHistoryCard = styled.div<{ withPadding?: boolean }>`
  display: flex;
  flex-direction: column;
  border-radius: ${borderRadius.lg};
  padding: ${({ withPadding = true }) => (withPadding ? spacing.base : 0)};
  ${mediumShadow};
  overflow: hidden;
  background-color: ${colors.backgroundPrimary};
`;

export const AlertHistoryList = styled.ul`
  all: unset;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: ${borderRadius.lg};
  > *:not(:last-child) {
    border-bottom: 1px solid ${colors.borderPrimarySubtle};
  }
`;

export const AlertHistoryListItem = styled.li<{ $hoverable?: boolean }>`
  all: unset;
  display: inline-flex;
  gap: ${spacing.half};
  padding: ${spacing.base};
  background-color: ${colors.backgroundPrimary};
  ${({ $hoverable = true }) =>
    $hoverable &&
    css`
      &:hover {
        cursor: pointer;
        background-color: ${colors.backgroundPrimaryHover};
      }
    `}
`;
